import SearchInput from "../../features/Search/components/SearchInput/SearchInput";
import ResultInform from "../../components/ResultInform/ResultInform";
import Header from "../../components/Header/Header";
import Bestsellers from "../../features/Search/components/Bestsellers/Bestsellers";
import { getCurrentDate } from "../../utils";
import ProductList from "../../features/Search/components/ProductList/ProductList";

// 이미지 사용할 경우
// import ProductList from "../../features/Search/components/ProductList/ProductImgList";

import useSearchHook from "#features/Search/hooks/useSearchHook";
import useProductList from "#features/Search/hooks/useProductList";
import useBestSellerHook from "#features/Search/hooks/useBestSellerHook";
import Renewal from "#src/features/Search/components/Renewal/Renewal.jsx";
import useTransferStore from "#src/features/Search/hooks/useTransferStore.js";
import useReactGASend from "#src/hooks/useReactGASend.js";

const date = getCurrentDate();

const ProductSearchPage = () => {
  const {
    areaCode,
    storeId,
    selectArea,
    branchList,
    keyword,
    handleInputChange,
    handleClearClick,
    selectBranch,
    search,
    sortType,
    setSortType,
    fetchMoreData,
    infinity,
    brandCd,
    isMounted,
  } = useSearchHook();

  const { productList, loaded, loading } = useProductList();
  const { rankList } = useBestSellerHook();
  const { brandId, number } = useTransferStore();
  const { makeEventTrackFn } = useReactGASend();

  const isRenewing = brandId === "ED";
  const showBestsellers = !loading && !keyword && !isRenewing;
  const showProductList = loaded && keyword && !isRenewing;
  const showNoResults =
    loaded && !loading && (productList.length === 0 || productList === null) && !isRenewing;

  return (
    <section className="p-hasHeader">
      <Header title="상품 검색" />
      {/* 에브리데이 상품검색 준비 중 */}
      {
        isRenewing && (
          <Renewal 
            number={number}
            isConnectToStore={true}
            onClick={() => {
              makeEventTrackFn({
                category: "event",
                action: "점포 연결 요청(상품검색)",
              });
            }}
          />
        )
      }

      {isMounted && !isRenewing && (
        <SearchInput
          areaCode={areaCode}
          selectArea={selectArea}
          storeId={storeId}
          handleInputChange={handleInputChange}
          handleClearClick={handleClearClick}
          branchList={branchList}
          selectBranch={selectBranch}
          search={search}
          keyword={keyword}
          sortType={sortType}
          setSortType={setSortType}
          loaded={loaded}
        />
      )}
      {/* 상품 검색 전 인기 상품 */}
      {showBestsellers && (
        <Bestsellers
          date={date}
          rankList={rankList}
          storeId={storeId}
          brandCd={brandCd}
        />
      )}
      {/* 상품 검색 후 상품 리스트 */}
      {showProductList && (
        <ProductList
          areaCode={areaCode}
          keyword={keyword}
          productList={productList}
          fetchMoreData={fetchMoreData}
          infinity={infinity}
          storeId={storeId}
          brandCd={brandCd}
          branchList={branchList}
        />
      )}
      {/* 상품 검색 결과 > 검색결과없음 */}
      {showNoResults && (
        <ResultInform
          label={
            <>
              검색 결과를 <br /> 찾을 수 없습니다.
            </>
          }
        />
      )}
    </section>
  );
};

export default ProductSearchPage;
